<img [src]="logoUri" [alt]="'Application_CompanyLogo' | translate" vbImageLoad/>